import {
  AfterViewChecked,
  ChangeDetectorRef,
  Component,
  OnInit,
  ViewChild,
  OnDestroy
} from '@angular/core';
import {ApiService} from '../../services/api.service';
import {AuthenticationService} from '../../services/authentication.service';
import {HttpParams} from '@angular/common/http';
import * as _ from 'lodash';
import * as moment from 'moment';
import {Message, SelectItem} from 'primeng/api';
import {NgbModal, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {CALENDAR_LOCALE} from '../../services/constant';
import {TemplateService} from '../../services/template.service';
import {SubSink} from 'subsink';

@Component({
  selector: 'app-tax-report',
  templateUrl: './tax-report.component.html',
  styleUrls: ['./tax-report.component.scss'],
  providers: [TemplateService]
})
export class TaxReportComponent implements OnInit, AfterViewChecked, OnDestroy {
  itemsPerPage = 40;

  calendarLocale = CALENDAR_LOCALE.TH;
  selectedCompany: SelectItem[];
  company: any;
  selectedHomeproGroup: SelectItem[];
  homeproGroup: any;
  startDate: Date;
  endDate: Date;
  minDate: Date;
  maxDate: Date;
  allBranch = true;
  allDocType = true;
  notApprove: any;
  branch: any;
  selectedBranch: SelectItem[];
  branchSuggest: any;
  typeSuggest: any;
  documentType: any;
  allDocumentType = [];
  allBranchSelected = [];
  tableData: any;
  modal: NgbModalRef;
  currentPage = 1;
  totalItems: number;
  loading = false;
  no_data = true;
  errorMsg = '';
  modalData: any;
  loadingExcel = false;
  loadingAllExcel = false;
  cofirm_loading = false;
  branchList: any = null;
  allBranchList: any = null;
  docTypeList: any = null;
  rdDocumentType: any;
  selectedRdDocumentType: any;

  sortBy: string;
  sortMode: string;

  tableCol = [
    {field: 'date', header: 'วันที่'},
    // { field: 'group', header: 'Business' },
    {field: 'branch', header: 'ชื่อสาขา'},
    {field: 'rd_doc_type', header: 'ประเภทเอกสาร'},
    // { field: 'doc_type', header: 'ประเภทเอกสารในองค์กร' },
    {field: 'start_end_document', header: 'เลขที่เอกสารเริ่ม/สิ้นสุด'},
    {field: 'total_doc', header: 'จำนวนเอกสาร'},
    {field: 'total_missing_doc', header: 'จำนวนเอกสารที่ขาด'},
    {field: 'non_vat', header: 'ยอดขาย Non-vat'},
    {field: 'basis_amount', header: 'ยอดขาย Vat'},
    {field: 'vat', header: 'Vat'}
  ];

  @ViewChild('content') content: any;
  @ViewChild('tt') table: any;

  private subs = new SubSink();

  constructor(
    private apiService: ApiService,
    private modalService: NgbModal,
    private cdr: ChangeDetectorRef,
    private authService: AuthenticationService,
    private template: TemplateService
  ) {
  }

  ngOnInit() {
    this.rdDocumentType = this.template.getDropdown(false);
    this.selectedRdDocumentType = this.rdDocumentType[0].value;

    this.loadInput();
  }

  get yearRange() {
    const thisYear = new Date().getFullYear();
    return thisYear - 40 + ':' + thisYear;
  }

  get dateRange() {
    const start = moment(this.startDate).format('DD/MM/YYYY');
    const end = moment(this.endDate).format('DD/MM/YYYY');
    return start + ' - ' + end;
  }

  ngAfterViewChecked() {
    this.cdr.detectChanges();
  }

  loadInput() {
    this.company = [];

    this.subs.add(
      this.apiService.getCompany().subscribe(result => {
        _.forEach(result, obj => {
          this.company.push({
            label: obj.name,
            value: obj.id
          });
        });

        if (result.length > 0) {
          this.selectedCompany = this.company[0].value;
          this.selectedBranch = this.company[0].value;
          this.pageChanged();
        }
      })
    );

    this.homeproGroup = [
      {
        label: 'ทั้งหมด',
        value: null
      }
    ];

    this.subs.add(
      this.apiService.getCompanyGroup().subscribe(result => {
        _.forEach(result, obj => {
          this.homeproGroup.push({
            label: obj.name,
            value: obj.id
          });
        });
      })
    );

    this.subs.add(
      this.apiService.getBranch().subscribe(result => {
        this.allBranchList = result;
        this.filterBranchList();
      })
    );

    this.startDate = new Date();
    this.startDate.setDate(this.startDate.getDate() - 60);
    this.endDate = new Date();
  }

  filterBranchList() {
    this.selectedBranch = null;

    this.branchList = [];

    _.forEach(this.allBranchList, obj => {
      if (this.selectedCompany == null || obj.corporate === this.selectedCompany) {
        this.branchList.push({
          label: obj.full_name,
          value: obj.id
        });
      }
    });

    if (this.branchList.length > 0) {
      this.selectedBranch = this.branchList[0].value;
    }
  }

  pageChanged() {
    const params = new HttpParams().set('page', _.toString(this.currentPage));
    this.searchData(params);
  }

  searchButtonClicked() {
    this.currentPage = 1;
    this.sortBy = null;
    this.sortMode = null;
    if (!this.no_data) {
      this.table.reset();
    }
    this.searchData();
  }

  setMinDate() {
    this.minDate = this.startDate;
    if (this.endDate < this.minDate) {
      this.endDate = this.minDate;
    }
  }

  setMaxDate() {
    this.maxDate = this.endDate;
    if (this.startDate > this.maxDate) {
      this.startDate = this.maxDate;
    }
  }

  canUserApproveDoc() {
    return this.authService.isAccountant() || this.authService.isUIH();
  }

  searchBranch(event) {
    if (this.branchList == null) {
      this.subs.add(
        this.apiService.getBranch().subscribe(data => {
          this.branchList = data;
          this.branchSuggest = this.filterData(event.query, 'full_name', this.branchList);
        })
      );
    } else {
      this.branchSuggest = this.filterData(event.query, 'full_name', this.branchList);
    }
  }

  searchDocumentType(event) {
    if (this.docTypeList == null) {
      this.subs.add(
        this.apiService.getDocumentType().subscribe(result => {
          this.docTypeList = result;
          this.typeSuggest = this.filterData(event.query, 'type', this.docTypeList);
        })
      );
    } else {
      this.typeSuggest = this.filterData(event.query, 'type', this.docTypeList);
    }
  }

  filterData(query, field, dataList) {
    query = query.toLowerCase().trim();

    const filtered: any[] = [];
    for (let i = 0; i < dataList.length; i++) {
      const data = dataList[i];
      if (data[field].toLowerCase().indexOf(query) >= 0) {
        filtered.push(data);
      }
    }
    return filtered;
  }

  selectAllBranch() {
    this.branch = null;
  }

  selectDocType() {
    this.documentType = null;
  }

  searchData(params?) {
    this.loading = true;
    this.checkCondition();

    if (this.errorMsg.length > 0) {
      this.loading = false;
      return;
    }

    this.allBranchSelected = [];
    this.allDocumentType = [];
    _.forEach(this.branch, obj => {
      // this.allBranchSelected = [];
      this.allBranchSelected.push(_.toNumber(obj.id));
    });
    _.forEach(this.documentType, obj => {
      // this.allDocumentType = [];
      this.allDocumentType.push(_.toNumber(obj.id));
    });

    const data = {
      not_approved_only: this.notApprove,
      header_issue_date_start: moment(this.startDate).format('YYYY-MM-DD'),
      header_issue_date_end: moment(this.endDate).format('YYYY-MM-DD'),
      corporate_group_id: this.selectedHomeproGroup,
      corporate_id: this.selectedCompany,
      document_type_id: _.isNil(this.documentType)
        ? this.documentType
        : _.uniq(this.allDocumentType),
      // branch_id: (_.isNil(this.branch)) ? this.branch : _.uniq(this.allBranchSelected),
      branch_id: this.selectedBranch ? [this.selectedBranch] : null,
      items_per_page: this.itemsPerPage,
      rd_doc_type: this.selectedRdDocumentType
    };

    if (this.sortBy && this.sortMode) {
      data['sort'] = this.sortBy;
      data['sort_type'] = this.sortMode;
    }

    if (this.currentPage === 1) {
      params = null;
    }

    this.subs.add(
      this.apiService.postSaleTax(data, params).subscribe(
        result => {
          this.loading = false;
          this.tableData = result.results;
          this.no_data = _.isEmpty(this.tableData);
          this.totalItems = result.count;
        },
        error => {
          this.loading = false;
          this.no_data = true;
          this.errorMsg = 'เกิดข้อผิดพลาด โปรดลองอีกครั้ง';
        }
      )
    );
  }

  confirmDocument(event, content, index) {
    // event.currentTarget.blur();
    document.getElementById('chkbox' + index).blur();
    event.preventDefault();

    this.modalData = this.tableData[index];
    this.modal = this.modalService.open(content, {backdrop: 'static', keyboard: false});
  }

  confirm() {
    this.cofirm_loading = true;

    const params = {
      approved: this.modalData.approved,
      header_issue_date: this.modalData.header_issue_date,
      group: this.modalData.group,
      document_type: this.modalData.document_type,
      rd_document_type: this.modalData.rd_document_type,
      corporate_branch: this.modalData.corporate_branch
    };

    this.subs.add(
      this.apiService.approveSale(params).subscribe(
        result => {
          this.cofirm_loading = false;
          this.modal.close();
          this.modal = null;
          this.sniff('APPROVE', 'sale');
        },
        error => {
          this.cofirm_loading = false;
        }
      )
    );
  }

  revertBack() {
    this.modalData.approved = !this.modalData.approved;
    this.modal.close();
    this.modal = null;
  }

  clearData() {
    this.tableData = undefined;
    this.no_data = true;
    this.startDate = new Date();
    this.startDate.setDate(this.startDate.getDate() - 60);
    this.endDate = new Date();
    this.selectedCompany = this.company.length === 1 ? this.selectedCompany : null;
    this.selectedBranch = this.company.length === 1 ? this.selectedBranch : null;
    this.branch = null;
    this.documentType = null;
    this.notApprove = false;
    this.allDocType = true;
    this.allBranch = true;
    this.sortBy = null;
    this.sortMode = null;

    this.searchButtonClicked();
  }

  exportRange() {
    const params = {
      header_issue_dt_start: moment(this.startDate).format('YYYY-MM-DD'),
      header_issue_dt_end: moment(this.endDate).format('YYYY-MM-DD'),
      rd_document_type: this.selectedRdDocumentType,
      corporate_branch: this.selectedBranch
    }
    this.subs.add(
      this.apiService.postAllDocsRange(params).subscribe(
        obj => {
          const filename = 'documents' + moment().format('YYYY-MM-DD') + '.xlsx';
          this.apiService.createDownloadFile(obj, filename);
        }
      )
    )
    this.sniff('DOWNLOAD_ALL_EXCEL', '');
  }

  getExportDocs(data, index) {
    // this.loadingAllExcel[index] = true;
    this.tableData[index].loading_all_docs_excel = true;

    const params = {
      header_issue_dt: data.header_issue_date,
      document_type: data.document_type,
      rd_document_type: data.rd_document_type,
      corporate_branch: data.corporate_branch,
      group: data.group
    };
    // const params = {
    //   month: moment(data.header_issue_date).format('MM'),
    //   year: moment(data.document_type).format('YYYY'),
    // };
    this.subs.add(
      this.apiService.getAllDocs(params).subscribe(
        obj => {
          this.tableData[index].loading_all_docs_excel = false;
          const filename = 'documents' + moment().format('YYYY-MM-DD') + '.xlsx';
          this.apiService.createDownloadFile(obj, filename);
          // data.xmlLoading = false;
          this.sniff('DOWNLOAD_EXCEL', filename);
        },
        error => {
          this.tableData[index].loading_all_docs_excel = false;
          // data.xmlLoading = false;
        }
      )
    );
    this.sniff('DOWNLOAD_ALL_EXCEL', '');
  }

  downloadMissingDocs(data, index) {
    this.tableData[index].loading_missing_docs_excel = true;
    // data.xmlLoading = true;
    const params = {
      header_issue_dt: data.header_issue_date,
      document_type: data.document_type,
      rd_document_type: data.rd_document_type,
      corporate_branch: data.corporate_branch,
      max_document: data.max_document,
      min_document: data.min_document,
      group: data.group
    };
    this.subs.add(
      this.apiService.getMissingDoc(params).subscribe(
        obj => {
          this.tableData[index].loading_missing_docs_excel = false;
          const filename = 'documents' + moment().format('YYYY-MM-DD') + '.xlsx';
          this.apiService.createDownloadFile(obj, filename);
          // data.xmlLoading = false;
          this.sniff('DOWNLOAD_EXCEL', filename);
        },
        error => {
          this.tableData[index].loading_missing_docs_excel = false;
          // data.xmlLoading = false;
        }
      )
    );
    this.sniff('DOWNLOAD_MISSING_EXCEL', '');
  }

  clearBranch() {
    this.allBranchSelected = [];
  }

  clearDocType() {
    this.allDocumentType = [];
  }

  stopPropagation(event) {
    event.stopPropagation();
  }

  checkCondition() {
    this.errorMsg = '';

    const errorMsgList = [];
    if (_.isEmpty(this.branch) && this.allBranch === false) {
      errorMsgList.push('สาขา');
    }

    if (_.isEmpty(this.documentType) && this.allDocType === false) {
      errorMsgList.push('Doc Type');
    }

    if (errorMsgList.length > 0) {
      this.errorMsg = 'กรุณาระบุ ' + errorMsgList.join(', ') + ' ให้ถูกต้อง';
      return;
    }

    const dayDiff = Math.abs(moment(this.endDate).diff(moment(this.startDate), 'days'));
    if (dayDiff > 60 && this.authService.isAccountant()) {
      this.errorMsg = 'ไม่สามารถเลือกระยะเวลาเกิน 60 วัน';
    }
  }

  sort(event) {
    this.sortBy = event.field;
    if (event.order === 1) {
      this.sortMode = 'asc';
    } else {
      this.sortMode = 'desc';
    }

    // this.searchData();
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }

  sniff(action, detail) {
    const data = {
      action: action,
      feature: 'SALE_TAX_REPORT',
      detail: detail
    };
    this.apiService.sniff(data).subscribe();
  }
}



// WEBPACK FOOTER //
// /opt/app/src/app/features/tax-report/tax-report.component.ts